import {
  AppNotSupportedFeature,
  ChatListItem,
  OnBoardingReviewsScreenPreviewFeature,
  SelectWithSearchFormFeature,
  ShareModalFeature,
  Textarea,
  SpecialistCardListWidget,
  SpecialistDetailWidget,
  FiltersWidget,
  SpecialistProfileNotFound,
  SessionsListWidget,
  SessionDetailWidget,
  SessionPaymentsWidget,
  ReviewTrialSessionFeature,
  ReviewSubscriptionSessionFeature,
  MindlyReviewFeature,
  SpecialistDetailWithTabsWidget,
  SpecialistCardWithScheduleWidget,
} from '@mindly/ui-components';
import { withTranslation } from 'react-i18next';
import { overrideTFn } from './shared/utils/temp';

export const TranslatedChatListItem = withTranslation('ui')(ChatListItem);

export const TranslatedShareModalFeature = withTranslation('ui')(ShareModalFeature);

export const TranslatedTextarea = withTranslation('ui')(Textarea);

export const TranslatedAppNotSupportedFeature = withTranslation('app')(AppNotSupportedFeature);

export const TranslatedSelectWithSearchFormFeature = withTranslation('ui')(SelectWithSearchFormFeature);

export const TranslatedOnBoardingReviewsScreenPreviewFeature = withTranslation('ui')(({ t, i18n, ...props }) => {
  return <OnBoardingReviewsScreenPreviewFeature t={overrideTFn(t, i18n)} {...props} />;
});

export const TranslatedSpecialistCardListWidget = withTranslation('ui')(({ t, i18n, ...props }) => {
  return <SpecialistCardListWidget t={overrideTFn(t, i18n)} {...props} />;
});
export const TranslatedSpecialistDetailWidget = withTranslation(['ui', 'reviews'])(({ t, i18n, ...props }) => {
  return <SpecialistDetailWidget t={overrideTFn(t, i18n)} {...props} />;
});
export const TranslatedSpecialistDetailWithTabsWidget = withTranslation(['ui', 'reviews'])(({ t, i18n, ...props }) => {
  return <SpecialistDetailWithTabsWidget t={overrideTFn(t, i18n)} {...props} />;
});
export const TranslatedFiltersWidget = withTranslation('ui')(FiltersWidget);

export const TranslatedSpecialistProfileNotFound = withTranslation('ui')(SpecialistProfileNotFound);
export const TranslatedSessionsListWidget = withTranslation('ui')(SessionsListWidget);
export const TranslatedSessionDetailWidget = withTranslation('ui')(SessionDetailWidget);
export const TranslatedSessionPaymentsWidget = withTranslation('ui')(SessionPaymentsWidget);

export const TranslatedReviewTrialSessionFeature = withTranslation('reviews')(ReviewTrialSessionFeature);
export const TranslatedReviewSubscriptionSessionFeature = withTranslation('reviews')(ReviewSubscriptionSessionFeature);
export const TranslatedMindlyReviewFeature = withTranslation('reviews')(MindlyReviewFeature);

export const TranslatedSpecialistCardWithScheduleWidget = withTranslation('ui')(({ t, i18n, ...props }) => {
  return <SpecialistCardWithScheduleWidget t={overrideTFn(t, i18n)} {...props} />;
});
